import { configureStore } from '@reduxjs/toolkit';

import authReducer from '~/redux/reducers/auth';
import cartReducer from '~/redux/reducers/cart';
import inventoryReducer from '~/redux/reducers/inventory';

export const makeStore = () =>
  configureStore({
    reducer: {
      auth: authReducer,
      cart: cartReducer,
      inventory: inventoryReducer,
    },
  });

// App-wide singleton store. Tests can call makeStore() for an isolated instance.
export const store = makeStore();

export type RootState = ReturnType<typeof store.getState>;
